import { TFunction } from 'i18next'
import { isObject } from 'lodash'

import { MessageData } from '../models'
import { getHardwareTestMessage } from './get-hardware-test-message'

/**
 * Returns translated default value based on the value type (string, object)
 * @param defaultValue - default value to translate
 * @param t - translation function
 * @returns translated default value
 */
export const getTranslatedDefaultValue = (defaultValue: MessageData | string | number | undefined, t: TFunction): string => {
  if (!defaultValue) {
    return ''
  }

  // Handle case where defaultValue is a MessageData object
  if (isObject(defaultValue)) {
    return getHardwareTestMessage(defaultValue, t)
  }

  // Handle case where defaultValue is another type (string, number, etc.)
  return defaultValue.toString()
}
